<template>
  <div>
    <el-dialog title="添加辅料" :visible.sync="dialogVisible" width="520px" @close="handleClose">
      <div class="template_warp">
        <div class="template_warp_item" v-for="item in templateList" :key="item.iteId">
          <div class="template_warp_item_left">
            <el-radio v-model="activeIteId" :label="item.iteId">{{ item.ingredientsStr }}</el-radio>
          </div>
          <div class="flex-sh">
            <i class="el-icon-edit-outline" @click="handleEdit(item)"></i>
            <i class="el-icon-delete ml14" @click="deleteTemplate(item.iteId)"></i>
          </div>
        </div>
        <div class="add_warp" @click="add">+ 自定义添加</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ingredientTemplateList, ingredientsTemplateDelete } from '@/api/ingredients'
import { isNull } from '@/utils/validateBase';
export default {
  props: {
    doctorId: {
      type: String | Number,
      value: ''
    },
  },
  data() {
    return {
      dialogVisible: false,
      radio: '',
      templateList: [],
      drugItemIndex: null,
      activeIteId: null
    }
  },
  methods: {
    handleClose() {
      this.drugItemIndex = null
      this.activeIteId = null
      this.templateList = []
      this.dialogVisible = false
    },
    async open(index) {
      this.drugItemIndex = index
      await this.getTemplateList()
      this.dialogVisible = true
    },
    add() {
      this.$emit('addIngredient',{type:'addTemplate',index:this.drugItemIndex})
    },
    async getTemplateList() {
      if (isNull(this.doctorId)) return;
      let { code, rows } = await ingredientTemplateList({ doctorId: this.doctorId })
      if (code == 200) {
        rows && rows.forEach(v1 => {
          v1.ingredientsStr = v1.ingredientsTemplateDetails.map(v2 => {
            let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
            if (v2.oriHandling) {
              str += v2.oriHandling;
            }
            return str;
          }).join('，');
        })
        this.templateList = rows || []
      }
    },
    confirm() {
      let obj = this.templateList.find(v => { return v.iteId == this.activeIteId })
      this.$emit('useTemplate', { ingredientsTemplateDetails: obj.ingredientsTemplateDetails, drugItemIndex: this.drugItemIndex })
      this.handleClose()
    },
    deleteTemplate(id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code} = await ingredientsTemplateDelete(id)
        if(code == 200){
          this.$message.success('删除成功')
          this.getTemplateList()
        }
      }).catch(() => {});
    },
    handleEdit(item){
      this.$emit('addIngredient',{type:'editTemplate',index:this.drugItemIndex,ingredient:item.ingredientsTemplateDetails,iteId:item.iteId})
    }
  }
}
</script>

<style lang="less" scoped>
.template_warp {
  height: 300px;
  overflow: auto;
}

.template_warp_item {
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #E0E0E0;
}

.template_warp_item_left {
  display: flex;
}
.el-radio {
  margin-right: 3px;
  white-space: normal;
}

.add_warp {
  padding-left: 26px;
  color: #1890FF;
  margin-top: 16px;
  cursor: pointer;
}
</style>